export const Bio = {
  name: "Yashas J Kumar",
  roles: [
    "Tech Explorer",
    "AI-ML Enthusiast",
    "Cyber Security Learner",
    "Programming Aficionado",
  ],
  description:
    "I am a motivated, consistent and versatile individual, always eager to take on new challenges.With a positive attitude and a growth mindset,I enjoy diving deep into the world of code and cyber defense.",
  github: "https://github.com/YashasJKumar",
  resume:
    "https://drive.google.com/file/d/1tm_cG2W94KggfikKkF-W0Te3vs5kLyfn/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/yashasjkumar/",
  twitter: "https://x.com/Yashas_J_Kumar",
  insta: "https://www.instagram.com/_yashas_j_k_/",
};

export const skills = [

  {
    title: "Programming Languages",
    skills: [
      {
        name: "C",
        image:
            "https://cdn.iconscout.com/icon/free/png-256/free-c-59-1175248.png",
      },
      {
        name: "C++",
        image:
            "https://i.pinimg.com/736x/51/45/df/5145df1033fa60f13b3b7125d2b69554.jpg",
      },
      {
        name: "Java",
        image:
            "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/java-programming-language-icon.png",
      },
      {
        name: "Python",
        image:
            "https://static.vecteezy.com/system/resources/previews/012/697/295/non_2x/3d-python-programming-language-logo-free-png.png",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://www.svgrepo.com/show/452185/css-3.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://www.svgrepo.com/show/452045/js.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Flask",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQj_GYArBWEH779VGiS5NPFV08GCxU_XX9Rub6DTFeQ55We_1PUGIStyuGMVcjBIT5MpK4&usqp=CAU",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Jinja2",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/Jinja_software_logo.svg/960px-Jinja_software_logo.svg.png?_=20181208104937",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Scikit-Learn",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3ioErrXCaT2yZgsMaefs8irg9dRTWVk882Q&s",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "JetBrains-IDE's",
        image:
          "https://www.svgrepo.com/show/353932/jetbrains.svg",
      },
      {
        name: "Streamlit",
        image:
            "https://images.ctfassets.net/23aumh6u8s0i/2Qhstbnq6i34wLoPoAjWoq/9f66f58a22870df0d72a3cbaf77ce5b6/streamlit_hero.jpg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.hpe.com/content/dam/hpe/newsroom/2025/06/hpe-marks-10-year-anniversary-with-bold-new-brand.jpg",
    role: "Project Intern",
    company: "HPE",
    date: "January 2024 - June 2024",
    desc: "Engineered an advanced AI-powered tool that leverages the capabilities of\n" +
        "large language models (LLMs) and generative AI to assist users in analyzing\n" +
        "and querying log files efficiently, providing valuable insights and simplifying\n" +
        "troubleshooting processes.",
    skills: [
      "Python",
      "Langchain",
      "LLM",
      "Vector Embeddings",
      "Streamlit",
      "Vector Databases",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRW6wELUMSuSckrpRCA2_uEq8FysIZAuTcyTQ&s",
    school: "R V College of Engineering, Bengaluru",
    date: "2025 - Present",
    grade: "9.24",
    desc: "I am currently pursuing my Master's in Computer Networking Engineering at RVCE, Bengaluru",
    degree: "Master of Technology - M.Tech, Computer Networking & Engineering",
  }, 
  {
    id: 1,
    img: "https://pbs.twimg.com/profile_images/1707471739532541954/A-02BbVK_400x400.jpg",
    school: "Vidyavardhaka College of Engineering, Mysuru",
    date: "2021 - 2025",
    grade: "9.4",
    desc: "I completed my Bachelor's degree in CSE(AIML) at Vidyavardhaka College of Engineering, Mysuru with a CGPA of 9.4",
    degree: "Bachelor of Engineering - B.E, Computer Science and Engineering(Artificial Intelligence & Machine Learning)",
  },
  {
    id: 2,
    img: "https://career.webindia123.com/career/institutes/aspupload/Uploads/karnataka/21502/logo.jpg",
    school: "Marimallappa's Pre-University College, Mysuru",
    date: "2019 - 2021",
    grade: "97.44%",
    desc: "I completed my class 12 at Marimallappa's Pre-University College, Mysuru",
    degree: "II-PUC -> PCMC",
  },
];

export const projects = [
  {
    id: 0,
    title: "Anonymous Recruitment",
    date: "Dec 2023",
    description:
      "A cutting-edge website crafted with Python Flask, Jinja2, Bootstrap, HTML, CSS and JS, designed to\n" +
        "streamline the initial stages of recruitment while ensuring anonymity for job seekers.\n" +
        "This ensures privacy of the candidates until Selection, thereby preventing data misuse.",
    image:
      "https://www.shrm.org/content/dam/en/shrm/topics-tools/news/talent-acquisition/202101-Talent-Trends-1_bi4qgd.gif",
    tags: [
      "HTML",
        "CSS",
        "JavaScript",
        "Flask",
        "Jinja2",
        "SMTP",
        "Werkzeug",
        "SQLAlchemy"
    ],
    category: "web app",
    github: "https://github.com/YashasJKumar/Anonymous_Recruitment",
    webapp: "https://github.com/YashasJKumar/Anonymous_Recruitment",
    member: [
      {
        name: "Yashas J Kumar",
        img: "https://avatars.githubusercontent.com/u/96472550?s=400&u=84332ef1d5f8824b4d4ee09922ff68b5b87c9fca&v=4",
        linkedin: "https://www.linkedin.com/in/yashasjkumar/",
        github: "https://github.com/yashasjkumar/",
      },
      {
        name: "Yashwanth Kumar A M",
        img: "https://avatars.githubusercontent.com/u/68020051?v=4",
        linkedin: "https://www.linkedin.com/in/yashwanthkumaram/",
        github: "https://github.com/yashwanthkumaram/",
      },
      {
        name: "Hariprasad Guttedar",
        img: "https://avatars.githubusercontent.com/u/96561749?v=4",
        linkedin: "https://www.linkedin.com/in/hariprasad-guttedar-aa112b24a/",
        github: "https://github.com/Hariguttedar",
      },
      {
        name: "Jeevan D M",
        img: "https://avatars.githubusercontent.com/u/96460761?v=4",
        linkedin: "https://www.linkedin.com/in/jeevan-d-m-b619a5228/",
        github: "https://github.com/jeevan-d-m",
      },
    ],
  },
  {
    id: 1,
    title: "Medical Chatbot",
    date: "Jan 2024",
    description:
      "A multi-lingual chatbot built with Llama2 , Gemini Pro Vision API ,\n" +
        "Streamlit UI finetuned to respond to medical related queries",
    image:
      "https://static.wixstatic.com/media/a89add_3d73f7e43cff4f37bdf0af4772ef6595~mv2.gif",
    tags: [
        "Gen AI",
        "LLM",
        "Langchain",
        "Streamlit",
        "Google Translate",
        "Pillow"
    ],
    category: "ai/ml",
    github: "https://github.com/YashasJKumar/Medical_ChatBot.git",
    webapp: "https://yunigma-med.streamlit.app",
    member: [
      {
        name: "Yashas J Kumar",
        img: "https://avatars.githubusercontent.com/u/96472550?s=400&u=84332ef1d5f8824b4d4ee09922ff68b5b87c9fca&v=4",
        linkedin: "https://www.linkedin.com/in/yashasjkumar/",
        github: "https://github.com/yashasjkumar/",
      },
      {
        name: "Yashwanth Kumar A M",
        img: "https://avatars.githubusercontent.com/u/68020051?v=4",
        linkedin: "https://www.linkedin.com/in/yashwanthkumaram/",
        github: "https://github.com/yashwanthkumaram/",
      },
      {
        name: "Hariprasad Guttedar",
        img: "https://avatars.githubusercontent.com/u/96561749?v=4",
        linkedin: "https://www.linkedin.com/in/hariprasad-guttedar-aa112b24a/",
        github: "https://github.com/Hariguttedar",
      },
      {
        name: "Jeevan D M",
        img: "https://avatars.githubusercontent.com/u/96460761?v=4",
        linkedin: "https://www.linkedin.com/in/jeevan-d-m-b619a5228/",
        github: "https://github.com/jeevan-d-m",
      },
    ],
  },
  {
    id: 2,
    title: "DocQuery",
    date: "Feb 2024",
    description:
        "Developed an innovative application,\n" +
        "“DocQuery,\n" +
        "” designed to transform document interaction using\n" +
        "advanced large language models (LLMs) and the Retrieval Augmented Generation (RAG) pipeline. This\n" +
        "project leverages state-of-the-art AI technologies to provide users with seamless and intelligent\n" +
        "document querying and content generation capabilities.",
    image:
        "https://cdnl.iconscout.com/lottie/premium/thumb/ai-reading-books-5647517-4703500.gif",
    tags: [
      "Gen AI",
      "LLM",
      "Langchain",
      "Streamlit",
      "Groq-Cloud",
      "Google Generative Embeddings"
    ],
    category: "ai/ml",
    github: "https://github.com/YashasJKumar/DocQuery.git",
    webapp: "https://docquery-app.streamlit.app",
    member: [
      {
        name: "Yashas J Kumar",
        img: "https://avatars.githubusercontent.com/u/96472550?s=400&u=84332ef1d5f8824b4d4ee09922ff68b5b87c9fca&v=4",
        linkedin: "https://www.linkedin.com/in/yashasjkumar/",
        github: "https://github.com/yashasjkumar/",
      },
    ],
  },
  {
    id: 3,
    title: "AI - Logistics Route Planner",
    date: "May 2024",
    description:
      "Our project integrates advanced technologies to revolutionize supply chain operations. With Flask, we've\n" +
        "created an intuitive interface for effortless interaction. Additionally, we harness the power of Large\n" +
        "Language Models (LLMs) for output generation, providing insightful analyses and forecasts.",
    image:
      "https://i.pinimg.com/originals/c4/9a/20/c49a207e0f89c9290d98fd43a87a8cb0.gif",
    tags: ["Flask", "Jinja2", "Werkzeug", "SMTP", "LLM", "Langchain", "Streamlit"],
    category: "web app",
    github: "https://github.com/YashasJKumar/Logistics_Management/",
    webapp: "https://github.com/YashasJKumar/Logistics_Management/",
    member: [
      {
        name: "Yashas J Kumar",
        img: "https://avatars.githubusercontent.com/u/96472550?s=400&u=84332ef1d5f8824b4d4ee09922ff68b5b87c9fca&v=4",
        linkedin: "https://www.linkedin.com/in/yashasjkumar/",
        github: "https://github.com/yashasjkumar/",
      },
      {
        name: "Yashwanth Kumar A M",
        img: "https://avatars.githubusercontent.com/u/68020051?v=4",
        linkedin: "https://www.linkedin.com/in/yashwanthkumaram/",
        github: "https://github.com/yashwanthkumaram/",
      },
      {
        name: "Hariprasad Guttedar",
        img: "https://avatars.githubusercontent.com/u/96561749?v=4",
        linkedin: "https://www.linkedin.com/in/hariprasad-guttedar-aa112b24a/",
        github: "https://github.com/Hariguttedar",
      },
      {
        name: "Jeevan D M",
        img: "https://avatars.githubusercontent.com/u/96460761?v=4",
        linkedin: "https://www.linkedin.com/in/jeevan-d-m-b619a5228/",
        github: "https://github.com/jeevan-d-m",
      },
    ],
  },
  {
    id: 4,
    title: "AI Powered Log-Parser",
    date: "Jul 2024",
    description:
      "A robust AI-powered solution that utilizes LLMs to parse device logs, identify patterns and anomalies, and provide " + 
      "actionable insights to diagnose system issues.",
    image:
      "https://cdn.dribbble.com/users/2058540/screenshots/8225403/media/bc617eec455a72c77feab587e09daa96.gif",
    tags: [
        "Gen AI",
        "LLM",
        "Langchain",
        "Streamlit",
        "Google Embedding",
        "FAISS DB"
    ],
    category: "ai/ml",
    github: "https://github.com/YashasJKumar/Log_Parser",
    webapp: "https://ai-log-parsing-tool.streamlit.app",
    member: [
      {
        name: "Yashas J Kumar",
        img: "https://avatars.githubusercontent.com/u/96472550?s=400&u=84332ef1d5f8824b4d4ee09922ff68b5b87c9fca&v=4",
        linkedin: "https://www.linkedin.com/in/yashasjkumar/",
        github: "https://github.com/yashasjkumar/",
      },
    ],
  },
  {
    id: 5,
    title: "Campus MarketPlace",
    date: "Jul 2026",
    description:
      "A secure, peer-to-peer mobile marketplace for verified university students, featuring a real-time negotiation engine and frictionless UPI payment integration.",
    image:
      "https://cdn-icons-gif.flaticon.com/6416/6416379.gif",
    tags: [
        "Javascript",
        "React Native",
        "Expo",
        "Firebase"
    ],
    category: "android-app",
    github: "https://github.com/YashasJKumar/CampusMarketPlace",
    webapp: "https://github.com/YashasJKumar/CampusMarketPlace",
    member: [
      {
        name: "Yashas J Kumar",
        img: "https://avatars.githubusercontent.com/u/96472550?s=400&u=84332ef1d5f8824b4d4ee09922ff68b5b87c9fca&v=4",
        linkedin: "https://www.linkedin.com/in/yashasjkumar/",
        github: "https://github.com/yashasjkumar/",
      },
    ],
  },
];

